import { regexp } from "@helpers/constants";

export const isValidForUrlPreview = (url: string) => {
  return (
    !!regexp.clickupTaskUrl.exec(url) ||
    !!regexp.salesforceOpportunityUrl.exec(url) ||
    !!regexp.hubspotDealUrl.exec(url) ||
    !!regexp.githubIssueUrl.exec(url) ||
    !!regexp.jiraIssueUrl.exec(url) ||
    !!regexp.linearIssueUrl.exec(url) ||
    !!regexp.linearProjectUrl.exec(url) ||
    !!regexp.youtrackIssueUrl.exec(url) ||
    !!regexp.youtrackProjectUrl.exec(url)
  );
};
